// applies CSS Styling of the Customization object to the root
export const applyCustomizationTheme = (customization: any) => {
  const root = document.documentElement;

  if (!customization || !customization.branding) {
    console.warn("Customization is missing. Applying default fallback colors.");
    root.style.setProperty("--header-bg-color", "#218838");
    root.style.setProperty("--header-text-color", "#ffffff");
    root.style.setProperty("--header-glow", "none");
    return;
  }

  const { branding } = customization;

  const headerColour = branding.headerBgColor || "#218838";
  const headerTextColour = branding.headerTxtColor || "#ffffff";

  const hoverColour = darkenHexColour(headerColour,10);

  root.style.setProperty("--header-bg-color", headerColour);
  root.style.setProperty("--header-text-color", headerTextColour);
  root.style.setProperty("--header-hover-color", hoverColour);
  root.style.setProperty("--header-glow", buildGlowShadow(branding.glow));
};

// Builds the CSS box-shadow that renders the banner glow. Intensity (0–100)
// scales the blur; a 0 (or missing) glow returns "none" so the banner has no
// shadow.
//
// The shadow is `inset` on purpose: the banner is `position: fixed; top: 0`
// and full-width, so an *outer* shadow can only spill downward past the bottom
// edge — which reads as the banner floating above the page and overlaps the
// scrolling content. An inset glow renders inside the banner's own edges, so
// it stays contained and doesn't affect (or appear to affect) the page scroll.
function buildGlowShadow(glow?: { color: string; intensity: number }): string {
  if (!glow || !glow.color) return "none";
  const intensity = Math.min(100, Math.max(0, glow.intensity || 0));
  if (intensity <= 0) return "none";
  const ratio = intensity / 100;
  const blur = (ratio * 50).toFixed(1);
  return `inset 0 0 ${blur}px 0 ${glow.color}`;
}


function darkenHexColour(hex: string, percent: number): string {
  const amt = Math.round(2.55 * percent);
  let R = parseInt(hex.substring(1, 3), 16);
  let G = parseInt(hex.substring(3, 5), 16);
  let B = parseInt(hex.substring(5, 7), 16);

  R = Math.max(0, R - amt);
  G = Math.max(0, G - amt);
  B = Math.max(0, B - amt);

  return `#${((R << 16) | (G << 8) | B).toString(16).padStart(6, '0')}`;
}

